export { CommunityPost as default } from '@/features/inquiry-library';
